const ErroeMessage = () => {
  return <img alt='Error on page' src={process.env.PUBLIC_URL + "/error.gif"} />;
};

export default ErroeMessage;